// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3d62L","info":"Note_info__2oPhI","note":"Note_note__2i4Em","actions":"Note_actions__3BAlp"};